// @ts-nocheck converted from existing component
// If making changes look to fix and remove this

import React from "react"
import { browserName, browserVersion } from "react-device-detect"
import { useContentJsx } from "@/utils/hooks/useContent"
import Notification from "@components/Notification/Notification"
import { VALID_BROWSERS } from "@/utils/helpers/mappings"

function BrowserWarning() {
  const { contentHeading, contentBody } = useContentJsx(
    "errors.browser_version_notice"
  )

  const yourVersion = Number(browserVersion)
  const validVersion = VALID_BROWSERS[browserName]

  if (yourVersion >= validVersion && typeof validVersion == "number") {
    return null
  }

  // browser is outdated
  return (
    <Notification
      notificationType={"alert"}
      heading={contentHeading}
      closeButton={true}
    >
      {contentBody}
    </Notification>
  )
}

export default BrowserWarning
